<div class="free-confirm-wrapper">
  <p class="free-confirm-icon">🏖️</p>
  <p class="free-confirm-heading">{{'free-week-confirmation.free' | translate }}</p>
  <p class="free-confirm-content">{{'free-week-confirmation.ready' | translate }}<br>{{'free-week-confirmation.to' |
    translate }}<br><br>
    {{'free-week-confirmation.No' | translate }}<br> {{'free-week-confirmation.account' | translate
    }}<br>{{'free-week-confirmation.do' | translate }}</p>
  <ion-button class="go-to-syndicate-btn" (click)="GoToSyndicates()">{{'free-week-confirmation.Syndicates' | translate
    }}</ion-button>
</div>